import React, { useEffect, useRef, useState } from 'react';
import { Drawer } from '@dsg-tech/homefield-react';
import { HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from '../../../../utility/constants';
import { AuthState, getAuthState } from '../../../../utility/auth-utils';
import SignedInState from './SignedInState/SignedInState';
import SignedOutState from './SignedOutState/SignedOutState';
import './MyAccountDrawer.scss';

interface MyAccountDrawerProps {
  headerRef: HTMLElement | null;
  showDrawer: boolean;
  setShowDrawer: () => void;
  closing: boolean;
  viewPortBreakpoint: string;
}

const MyAccountDrawer = ({
  headerRef,
  showDrawer,
  setShowDrawer,
  closing,
  viewPortBreakpoint,
}: MyAccountDrawerProps) => {
  const [auth, setAuth] = useState<AuthState>({ name: undefined, isLoggedIn: false });
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const timeoutRef = useRef(null);
  useEffect(() => {
    getAuthState().then((authState: AuthState) => {
      setAuth(authState as AuthState);
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (auth.isLoggedIn) {
      setIsUserLoggedIn(true);
    }
  }, [auth]);

  const handleClickProfileMenu = () => {
    setShowProfileMenu(true);
  };

  const handleKeydownProfileMenu = (event: React.KeyboardEvent) => {
    if (event.keyCode === KEY_CODES.SPACE || event.keyCode === KEY_CODES.ENTER) {
      setShowProfileMenu(true);
    }
  };

  return (
    <Drawer
      className="myaccount-drawer-container"
      id="myAccountDrawerContainer"
      anchorElement={viewPortBreakpoint === 'mobile' ? null : headerRef?.current}
      attachedBackground={viewPortBreakpoint !== 'mobile'}
      interactability={viewPortBreakpoint === 'mobile'}
      open={showDrawer}
      closing={closing}
      closable={false}
      onCloseModal={() => setShowDrawer()}
      direction="right">
      <div className="my-account-drawer-content-container">
        <div className="my-account-drawer-header hmf-display-flex hmf-flex-row hmf-justify-content-between">
          <span className="my-account-drawer-title hmf-header-bold-m hmf-display-flex hmf-ml-m hmf-align-items-center">
            My Account
          </span>
          <div
            className="close-icon-container hmf-p-xxs hmf-m-xxs"
            role="button"
            aria-label="Close menu"
            onClick={() => setShowDrawer()}
            onKeyDown={(event) => {
              if (event.keyCode === KEY_CODES.SPACE || event.keyCode === KEY_CODES.ENTER) {
                setShowDrawer();
              }
            }}
            tabIndex={0}>
            <HomefieldIconSignCancel width="32" height="32" />
          </div>
        </div>
        <div className="my-account-drawer-body">
          {isUserLoggedIn ? (
            <SignedInState
              handleClickProfileMenu={handleClickProfileMenu}
              handleKeydownProfileMenu={handleKeydownProfileMenu}
            />
          ) : (
            <SignedOutState />
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default MyAccountDrawer;
